import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../configs/AADB2CConfig";
import { EventType } from "@azure/msal-browser";


console.log(msalConfig.auth.redirectUri)

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});